import { BrowserRouter, Navigate, useRoutes } from 'react-router-dom';
import CreatorCash from './pages/CreatorCash/CreatorCash';
import CreatorCashProvider from './context/CreatorCashProvider';
import Privacy from './pages/Privacy/Privacy';
import Terms from './pages/Terms/Terms';

const AppRouter = () => {

  return useRoutes([
    {
      path: '/terms', element: (
        <Terms />
      )
    },
    {
      path: '/privacy', element: (
        <Privacy />
      )
    },
    {
      path: '/', element: (
        <CreatorCashProvider>
          <CreatorCash />
        </CreatorCashProvider>
      )
    },
    { path: '*', element: <Navigate to={'/'} replace /> },
  ]);
};

export default function App() {
  return (
    <BrowserRouter>
      <AppRouter />
    </BrowserRouter>
  )
};
